export default "__VITE_ASSET__44866449__"